module.exports = __webpack_public_path__ + "img/orangeLight.0cabd822.svg";